import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { type StockStatusOption } from "../../types";
import { type StockStatusCounts } from "../../useStockStatusCounts";
import { STOCK_STATUS_OPTIONS } from "../../utils";

interface StockStatusTabsProps {
  value: StockStatusOption;
  onChange: (value: StockStatusOption) => void;
  counts: StockStatusCounts;
  isLoading: boolean;
}

/**
 * Quick filters over the Stock status filter, with the country-wide count of each option.
 * Edited stock is also for sale and split stock can be in any status, so the counts overlap.
 */
export const StockStatusTabs = ({ value, onChange, counts, isLoading }: StockStatusTabsProps) => {
  const { t } = useTranslation();

  return (
    <Tabs value={value} onValueChange={next => onChange(next as StockStatusOption)}>
      <TabsList
        aria-label={t("farmersMarket.stockStatusTabsLabel")}
        className="max-w-full gap-1 overflow-x-auto rounded-xl p-1 group-data-[orientation=horizontal]/tabs:h-auto"
      >
        {STOCK_STATUS_OPTIONS.map(option => (
          <TabsTrigger key={option} value={option} className="flex-none gap-2 rounded-lg px-4 py-2">
            {t(`farmersMarket.stockStatus.${option}`)}
            {!isLoading && (
              <Badge variant={value === option ? "default" : "secondary"} className="tabular-nums">
                {counts[option] ?? 0}
              </Badge>
            )}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
